import { render, staticRenderFns } from "./shopBanners.vue?vue&type=template&id=b374e78a&scoped=true"
import script from "./shopBanners.vue?vue&type=script&lang=js"
export * from "./shopBanners.vue?vue&type=script&lang=js"
import style0 from "./shopBanners.vue?vue&type=style&index=0&id=b374e78a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b374e78a",
  null
  
)

export default component.exports